<template>
  <v-card>
    <v-card-title>{{title}}</v-card-title>
    <v-card-text>
      <RightsLocationsMultipleUsersAutocomplete
        :organizationUsers="organizationUsers"
        :locations="locations"
        v-on:addUsersToLocations="add"
        v-on:removeUsersToLocations="remove"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import RightsLocationsMultipleUsersAutocomplete from "@/components/Access/Rights/RightsLocationsMultipleUsersAutocomplete";

export default {
  components: { RightsLocationsMultipleUsersAutocomplete },
  props: {
    title: { type: String },
    organizationUsers: { type: Array },
    locations: { type: Array },
  },
  data: () => {
    return {};
  },
  computed: {},
  methods: {
    add(users, locations, rights) {
      this.$emit("add", users, locations, rights);
    },
    remove(users, locations, rights) {
      this.$emit("remove", users, locations, rights);
    },
  },
};
</script>

<style>
</style>